import React from 'react';
import Nav from './Nav/Navbar';
import Hero from './Hero/Hero';
import HowItWorks from './howItWorks/howItWorks';
import Widget from '../Widget/Widget';

import '../styles/landing_page.css';

function LandingPageContainer() {
	return (
		<div className="landing_page_container">
			{/* Nav Component */}
			<div>
				<Nav />
			</div>
			{/*  Hero Component */}
			<div id="Hero">
				<Hero />
			</div>
			{/* How it works Component */}
			<div id="HowItWorks">
				<HowItWorks />
			</div>

			<div className="widget">
				<Widget />
			</div>
		</div>
	);
}

export default LandingPageContainer;
